import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerDown = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const Download = styled.a`
  width: 200px;
  display: flex;
  font-size: 16px;
  border-radius: 6px;
  justify-content: right;
  align-items: right;
  bottom: 25px;
  padding: 10px;
  cursor: pointer;
  transition: filter 0.2s;
  background-color: #60a5fa;
  color: #ffffff;
  margin-top: 20px;
  margin-left: 2px;



  &:hover {
    transition: 0.2s; 
    background-color:rgb(67, 141, 233);
  }
`;

export const ButtonStyled = styled.button`
  margin: auto;
  color: #fff;
  background: #22C55E;
  border: transparent;
  border-radius: 10px;
  font-size: 16px;
  padding: 0.9em;
  cursor: pointer;
  transition: filter 0.2s;
  width: 160px;
  justify-content: center;
  display: flex;
  align-items: center;

  &:hover {
    transition: 0.3s;
    background-color: #189546;
  }

  &:disabled {
    opacity: 60%;
    filter: brightness(1);
    cursor: no-drop;
    background-color: #22C55E;
  }
`;

export const ReportButton = styled.button`
  width: 2.5rem;
  height: 2.5rem;

  display: flex;

  color: #ffffff;
  background: linear-gradient( #9300f7, #202df0);
  border: transparent;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  transition: filter 0.3s;

  justify-content: center;
  align-items: center;

  &:hover {
    transition: 0.3s;
    background: linear-gradient(#560091,#1f2adb);
  }

  &:disabled {
    opacity: 50%;
    filter: brightness(1);
    cursor: default;
    background:linear-gradient(#9300f7,#202df0);
  }
`;

export const Errors = styled.div`
  background-color: #fed8d7;
  max-width: 650px;
  padding: 16px 8px;
  border-radius: 12px;
  max-height: 250px;
  overflow: auto;

  .title {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .error {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
  }

  i {
    font-size: 2rem;
    background: #fff;
    color: #932f2f;
    border-radius: 20px;
  }
`;

export const Teste = styled.div`
  .data {
    tbody {
      tr {
        margin-top: 8px;
        border: 1px solid red;
        border-radius: 12px;

        td {
          border: none;
        }
      }

      :last-child {
        margin-bottom: 8px;
      }
    }
  }
`;

export const Resume = styled.div`
  height: 55px;
  width: 320px;
  font-size: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;

  span {
    display: flex;
    align-items: center;
    padding: 14px;
    color: #fff;
    background: #22C55E;
    border-radius: 12px;

    i {
      font-size: 24px;
    }
  }

  label {
    font-weight: bold;
  }
`;

export const Status = styled.div`
  border: 1px solid grey;
  border-radius: 12px;
  max-width: 685px;
  /* max-width: 50%; */

  div {
    display: flex;
    flex-direction: column;

    label {
      margin-left: 8px;
    }
  }

  div:last-child {
    margin-left: 16px;
    max-width: 320px;
    background: #22C55E;
    border-radius: 30px;
    color: #fff;
  }
`;
